import cbbcThemeColors from "@/Themes/cbbcTheme.js";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, fa } from "vuetify/iconsets/fa";
import "../../scss/CustomVuetify.scss";

const cbbcTheme = {
    dark: false,
    colors: cbbcThemeColors,
    variables: {
        "medium-emphasis-opacity": "1",
        "high-emphasis-opacity": "1",
        "border-opacity": "1",
        "border-color": "#E0E0E0",
        "disabled-opacity": "0.8",
        "btn-size": "16px",
        "font-size-page-heading": "1.25rem",
    },
};

const defaultButtonObject = {
    color: "primary",
    variant: "flat",
    slim: false,
};

const vuetify = createVuetify({
    components: {
        ...components,
    },
    directives: {
        ...directives,
    },
    icons: {
        defaultSet: "fa",
        aliases,
        sets: {
            fa,
        },
    },
    theme: {
        defaultTheme: "cbbcTheme",
        themes: {
            cbbcTheme,
        },
    },
    defaults: {
        VBtn: defaultButtonObject,
        VCardActions: {
            VBtn: defaultButtonObject,
        },
        VCard: {
            flat: true,
        },
        VCheckbox: {
            color: "primary",
        },
    },
});

export default vuetify;
